import React from 'react';
import PropTypes from 'prop-types';

import { InputTitle, InputWrapper, FieldLabelWrapper } from './css';
import Note from '../../note';
import formFieldOperationOptions from '../../utils/formFieldOperationOptions';
import FieldGuide from './common/fieldGuide';
import FieldTitle from './common/FieldTitle';

const FieldTextArea = ({ data }) => {
  const {
    ref,
    name,
    label,
    value,
    title,
    required,
    placeholder,
    maxLength,
    minLength,
    onChange,
    readonly,
    tooltip,
    tooltipLong,
    toolTipRichText,
    note,
    disabled
  } = data;

  const renderNotes = () => {
    return (
      note &&
      note.content && (
        <Note
          type="richText"
          options={formFieldOperationOptions(value)}
          data={note}
        />
      )
    );
  };

  const style = {
    height: '120px'
  };
  const tooltipMessage = tooltip || tooltipLong || toolTipRichText;

  return (
    <>
      {title && <InputTitle>{title}</InputTitle>}
      <InputWrapper>
        {renderNotes()}
        <FieldLabelWrapper>
          <FieldTitle required={required} label={label} />
          {tooltipMessage && (
            <FieldGuide tooltip={tooltipMessage} isRichText={toolTipRichText} />
          )}
        </FieldLabelWrapper>
        <textarea
          ref={ref}
          id={name}
          name={name}
          value={value}
          maxLength={maxLength}
          minLength={minLength}
          readOnly={readonly}
          placeholder={placeholder}
          disabled={disabled}
          className="frg-input-field color-light"
          style={style}
          onChange={onChange}
        />
      </InputWrapper>
    </>
  );
};

FieldTextArea.propTypes = {
  data: PropTypes.shape({
    ref: PropTypes.object,
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    value: PropTypes.string,
    title: PropTypes.string,
    required: PropTypes.bool,
    placeholder: PropTypes.string,
    maxLength: PropTypes.number,
    minLength: PropTypes.number,
    onChange: PropTypes.func.isRequired,
    readonly: PropTypes.bool,
    disabled: PropTypes.bool,
    tooltip: PropTypes.string,
    tooltipLong: PropTypes.string,
    toolTipRichText: PropTypes.shape({
      content: PropTypes.arrayOf(PropTypes.object)
    }),
    note: PropTypes.shape({
      content: PropTypes.arrayOf(PropTypes.object)
    })
  }).isRequired
};

export default FieldTextArea;
